import _ from 'lodash'

const SEMICONDUCTORS_NAV_CONFIG = {
    section: _.select( '.c-section--business-semiconductors-solutions-grid .solutions__sidebar' ),
    lines: _.selectAll( '.c-section--business-semiconductors-solutions-grid .solutions__sidebar a.solution__line' ),
    types: _.selectAll( '.c-section--business-semiconductors-solutions-grid .solutions__sidebar a.solution__type' ),
    formats: _.selectAll( '.c-section--business-semiconductors-solutions-grid .solutions__sidebar a.solution__format' )
}

export default SEMICONDUCTORS_NAV_CONFIG
